export const solidWhite = '#fff';
export const scienceBlue = '#0069d2';



// WEBPACK FOOTER //
// ./src/theme.js